import { NgModule } from '@angular/core';
import { LibWarningIconComponent } from './lib-warning-icon.component';

@NgModule({
  declarations: [LibWarningIconComponent],
  exports: [LibWarningIconComponent],
})
export class LibWarningIconModule {}
